import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Direction B ("warm") is a prototype scoped to three screens: the dashboard, the invoice list and the invoice
 * composer. Everything else keeps the current design. The attribute lives on <html> (not on a wrapper) so
 * Radix portals — menus, popovers, sheets, dialogs — which render under <body>, inherit the same tokens.
 */
export function isWarmPath(pathname: string): boolean {
  return pathname === '/dashboard' || pathname === '/invoices' || pathname === '/invoices/new' || /^\/invoices\/[^/]+\/edit$/.test(pathname);
}

/** The composer carries its own sticky action bar, so the phone tab bar steps aside there. */
export function isComposerPath(pathname: string): boolean {
  return pathname === '/invoices/new' || /^\/invoices\/[^/]+\/edit$/.test(pathname);
}

export function useWarmDirection(): boolean {
  const { pathname } = useLocation();
  const warm = isWarmPath(pathname);
  useEffect(() => {
    const root = document.documentElement;
    if (warm) root.dataset.direction = 'warm';
    else delete root.dataset.direction;
    return () => void delete root.dataset.direction;
  }, [warm]);
  return warm;
}
